import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./service";

export const addCityAction = createAsyncThunk(
  "admin/addCityAction",
  async (addCityData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_TEST_API}/city`,
        addCityData,
        { headers: myHeaders() }
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error) {
        return rejectWithValue(error.message);
      }
    }
  }
);
